"use client";

import { LanguageContext } from "@/context/languageContext";
import { GymAndWellnessOptionsQuery } from "@/types/wordpressQueries";
import { useContext, useEffect } from "react";
import Splash from "../Splash";
import Tabs from "../Tabs";
import Featured from "../Featured";
import Introduction from "@/components/Introduction";
import { GymAndWellness } from "@/types/wordpress";
import { FeaturedComponent, TabsComponent } from "@/types/modules";
import { useLanguageUrl } from "@/context/languageURLContext";

interface GymAndWellnessComponentProps {
  data: GymAndWellnessOptionsQuery;
  wellness: GymAndWellness[];
}

export default function GymAndWellnessComponent({
  data,
  wellness,
}: GymAndWellnessComponentProps) {
  const { language } = useContext(LanguageContext);

  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(`/${language === "en" ? "de" : "en"}/gym-and-wellness`);
  }, [language, setUrl]);

  const featured: FeaturedComponent = {
    backgroundColor:
      language === "en"
        ? data.spaGymOptions.featured.backgroundColor
        : data.spaGymOptionsDE.featured.backgroundColor,
    title:
      language === "en"
        ? data.spaGymOptions.featured.title
        : data.spaGymOptionsDE.featured.title,
    custom:
      language === "en"
        ? data.spaGymOptions.featured.custom
        : data.spaGymOptionsDE.featured.custom,
  };

  let tabs: TabsComponent[] = [];

  wellness.map((item) => {
    tabs.push({
      title: language === "en" ? item.title : item.translations[0].title,
      slug: language === "en" ? item.slug : item.translations[0].slug,
      imageAlign:
        language === "en"
          ? item.contentFields.imageAlign
          : item.translations[0].contentFields.imageAlign,
      textAlign:
        language === "en"
          ? item.contentFields.textAlign
          : item.translations[0].contentFields.textAlign,
      content:
        language === "en"
          ? item.contentFields.body
          : item.translations[0].contentFields.body,
      gallery:
        language === "en"
          ? item.contentFields.gallery
          : item.translations[0].contentFields.gallery,
      button:
        language === "en"
          ? item.contentFields.button
          : item.translations[0].contentFields.button,
    });
  });

  return (
    <>
      {language === "en"
        ? data.spaGymOptions.slider &&
          data.spaGymOptions.slider.slider && (
            <Splash slider={data.spaGymOptions.slider.slider} />
          )
        : data.spaGymOptionsDE.slider &&
          data.spaGymOptionsDE.slider.slider && (
            <Splash slider={data.spaGymOptionsDE.slider.slider} />
          )}
      <Introduction
        title={
          language === "en"
            ? data.spaGymOptions.introduction.title
            : data.spaGymOptionsDE.introduction.title
        }
        content={
          language === "en"
            ? data.spaGymOptions.introduction.content
            : data.spaGymOptionsDE.introduction.content
        }
      />
      <Tabs tabs={tabs} />
      <Featured featured={featured} />
    </>
  );
}
